import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";

interface UseCardMarkAsShippedProps {
  onSuccess?: () => void;
  onError?: (error: ErrorResponse) => void;
}

export const useCardMarkAsShipped = ({ onSuccess, onError }: UseCardMarkAsShippedProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['clientCardsMarkAsShipped'],
    mutationFn: async (ids: string[]) => {
      await privateAxios.post(`/client/cards/bulk_mark_as_shipped`, {
        cards: { ids },
      });
    },
    onSuccess,
    onError,
  });
};
